<script setup lang="ts">
import { useAuthenticatedUserStore } from "@/modules/authentication/authentication-store";
import { onMounted } from "vue";

const store = useAuthenticatedUserStore();

onMounted(async () => {
  await store.userLogout();
});
</script>

<template>
  <div class="row">
    <div class="col">
      <h1>Du loggas nu ut</h1>
    </div>
  </div>
</template>
